import { render, staticRenderFns } from "./allCommodities.vue?vue&type=template&id=27b8ca6e&scoped=true&"
import script from "./allCommodities.vue?vue&type=script&lang=js&"
export * from "./allCommodities.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/bootstrap.min.css?vue&type=style&index=0&lang=css&"
import style1 from "../assets/css/style.css?vue&type=style&index=1&id=27b8ca6e&scoped=true&lang=css&"
import style2 from "../assets/css/style-surya.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b8ca6e",
  null
  
)

export default component.exports